"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ListItem = exports.List = exports.Link = exports.IconChevronRight = exports.Header = exports.CloseButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconChevronDown = _interopRequireDefault(require("../../../../IconFlippingChevron/IconChevronDown"));

var _index = require("../MobileNavMenu/index.styles"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Wrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Wrapper",
  componentId: "sc-mea4be-0"
})(["position:fixed;bottom:", ";left:0;z-index:2;width:100%;background-color:", ";transform:translate(0,100%);transition:transform 120ms ease-out;&.slide-in-enter-done{transform:translate(0,0);}&.slide-in-exit-done{transition:transform 80ms ease-in;transform:translate(0,100%);}"], _index.mobileNavigationHeight, function (p) {
  return p.theme.tokens.colorBackground;
});

exports.Wrapper = Wrapper;

var Header = /*#__PURE__*/_styledComponents["default"].header.withConfig({
  displayName: "indexstyles__Header",
  componentId: "sc-mea4be-1"
})(["padding-top:0.5rem;text-align:right;"]);

exports.Header = Header;

var StyledCloseButton = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  displayName: "indexstyles__StyledCloseButton",
  componentId: "sc-mea4be-2"
})(["padding:0;width:2rem;height:2rem;overflow:hidden;border:none;margin:0.5rem 1rem;line-height:0;color:", ";background:none;&::before{display:block;content:'\u2715';font-size:2rem;}"], function (p) {
  return p.theme.tokens.colorPaletteGray600;
});

var CloseButton = function CloseButton(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledCloseButton, (0, _extends2["default"])({
    type: "button",
    title: "Navigatie sluiten"
  }, props));
};

exports.CloseButton = CloseButton;

var List = /*#__PURE__*/_styledComponents["default"].ul.withConfig({
  displayName: "indexstyles__List",
  componentId: "sc-mea4be-3"
})(["list-style:none;padding:0;margin:0.5rem;"]);

exports.List = List;

var ListItem = /*#__PURE__*/_styledComponents["default"].li.withConfig({
  displayName: "indexstyles__ListItem",
  componentId: "sc-mea4be-4"
})(["border-top:1px solid ", ";"], function (p) {
  return p.theme.tokens.colorPaletteGray300;
});

exports.ListItem = ListItem;

var Link = /*#__PURE__*/_styledComponents["default"].a.withConfig({
  displayName: "indexstyles__Link",
  componentId: "sc-mea4be-5"
})(["position:relative;display:block;padding:0.75rem 1rem;text-decoration:none;color:", ";&.active{font-weight:bold;color:", ";}"], function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.tokens.colorPaletteBlue800;
});

exports.Link = Link;
var IconChevronRight = /*#__PURE__*/(0, _styledComponents["default"])(_IconChevronDown["default"]).withConfig({
  displayName: "indexstyles__IconChevronRight",
  componentId: "sc-mea4be-6"
})(["position:absolute;top:50%;right:1rem;margin-top:-6px;transform:rotate(-90deg);path{fill:", ";}"], function (p) {
  return p.theme.tokens.colorPaletteGray400;
});
exports.IconChevronRight = IconChevronRight;